// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3gHx8","alertIcon":"ConfirmModal_alertIcon__2r0KP"};